import { Box } from '@mui/material';

import { Metadata } from '@redwoodjs/web';
import { RiGroup2Fill } from '@remixicon/react';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';
import { AgTab, AgTabs } from 'src/components/ui/AgTabs';
import AiForwardingConfirmationBanner from './AiForwardingConfirmationBanner';
import People from './people/People';

export enum TeamSettingsTabs {
  PEOPLE = 'people',
}

export default function TeamSettingsPage() {
  return (
    <>
      <Metadata title="Team Settings" />
      <PageHeader pageType={PageType.TeamSettings}></PageHeader>
      <PageBody>
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <AiForwardingConfirmationBanner />
          <AgTabs queryParam="tab">
            <AgTab id={TeamSettingsTabs.PEOPLE} label="People" icon={<RiGroup2Fill size={20} />}>
              <People />
            </AgTab>
          </AgTabs>
        </Box>
      </PageBody>
    </>
  );
}
